import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vuelidate from "vuelidate";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "bootstrap-3-grid/bootstrap-3-grid.css";
import "./assets/css/global.css";
// import "@fortawesome/fontawesome-pro/css/all.css";
import "vue-good-table/dist/vue-good-table.css";
import locale from "element-ui/lib/locale/lang/en";
import VCharts from "v-charts";
import VeCharts from "ve-charts";
import VModal from "vue-js-modal";
import VueTimeago from "vue-timeago";
import VueTextareaAutosize from "vue-textarea-autosize";
import VueTour from "vue-tour";
import GmapVue from "gmap-vue";
import VueZoomer from "vue-zoomer";
import VueClipboard from "vue-clipboard2";
import "vue-tour/dist/vue-tour.css";
import "vue-wysiwyg/dist/vueWysiwyg.css";
import wysiwyg from "vue-wysiwyg";

import VueGoodTablePlugin from "vue-good-table";

Vue.use(wysiwyg, {
  hideModules: {
    justifyLeft: true,
    justifyCenter: true,
    justifyRight: true,
    headings: true,
    image: true,
    table: true,
    link: true,
  },
  paragraphSeparator: "br",
  // forcePlainTextOnPaste: true
});
Vue.use(GmapVue, {
  load: {
    key: "AIzaSyCN94noyQX1JyljLIwnaWs3K9NpVK4whDc",
    libraries: "places",
    // mapId: "accfc72fe6b2bc0b",
  },

  installComponents: true,
});
Vue.use(VueTour);
Vue.use(Vuelidate);
Vue.use(ElementUI, { locale });
Vue.use(VCharts);
Vue.use(VeCharts);
Vue.use(VueTextareaAutosize);
Vue.use(VueZoomer);
Vue.use(VueGoodTablePlugin);
Vue.use(VModal, { dynamic: true, dynamicDefaults: { clickToClose: true } });
Vue.use(VueTimeago, {
  name: "Timeago", // Component name, `Timeago` by default
  locale: "en", // Default locale
});
Vue.use(VueClipboard);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  beforeCreate() {
    this.$store.commit("initialiseStore");
    // Vue.prototype.$globalLoading = "test";
  },
  render: (h) => h(App),
}).$mount("#app");
